module.exports = function (data) {

    if (data) {
        // cross sell type can come through a new tab and from an angular11 application
        const url = new window.URLSearchParams(window.location.search);

        const propertiesToUpdate = ['typeOfCrossSell', 'eventCampaignName', 'eventPlace', 'eventPosition', 'eventType'];
        const dynamicCrossSellType = url.get('typeOfCrossSell');
        const hasNoCrossSell = !data.typeOfCrossSell;
        propertiesToUpdate.forEach((property) => {
            const queryParamValue = url.get(property);
            if (!data[property] && dynamicCrossSellType && queryParamValue && hasNoCrossSell) {
                data[property] = queryParamValue;
            }
        });
    }
};



/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/trolley/atmmapper/override-add-trolley-mapper.js
 **/